module.exports = __webpack_public_path__ + "img/乐途_04.ae6df31d.jpg";